// extracted by mini-css-extract-plugin
export var completed = "DeliveryNoteSelectItem-module--completed--Acf+1";
export var found = "DeliveryNoteSelectItem-module--found--96WI4";
export var noItems = "DeliveryNoteSelectItem-module--noItems--dWhgU";
export var noteOrderStatus = "DeliveryNoteSelectItem-module--noteOrderStatus--EZJld";
export var notfound = "DeliveryNoteSelectItem-module--notfound--O7Ic7";